import service from '@/middleware'

const bussinesTargetApi = {

   async getStateTargets(){
    const stateTargets = await service.http.get(`/api/bussinesTarget/getStateTargets`);
    return stateTargets;

   },

   async createUpdateManyStateTarget(objetives){
      const result =  await service.http.post(`/api/bussinesTarget/createUpdateManyStateTarget`, {statesTarget: objetives});
      return result;
   },

   async delete(thingIds){
      const response = await service.http.put(`/api/bussinesTarget/delete`, thingIds);
      return response;
  
     },
}

export default bussinesTargetApi;